import { ArraySerializer, Field, Model, Type } from 'serialize-ts';
import { Thumbnail } from './thumbnail.model';
import { ModelMetadataSerializer } from 'serialize-ts/dist/serializers/model-metadata.serializer';

@Model()
export class ProductImage {
  @Field()
  id: string;

  @Field()
  url: string;

  @Field()
  alt: string;

  @Field()
  main: boolean;

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(Thumbnail)))
  sizes: Thumbnail[];
}
